import BaseIdleState from 'Engine/states/IdleState';
import EntryPoint from 'Engine/EntryPoint';

export default class IdleState extends BaseIdleState {
  start() {
    EntryPoint.SystemUiAdapter.handleWinLimits();
    super.start();
  }
}
